import { useEffect, useState } from 'react';
import './TeacherInvitedAfterMeeting.scss';

const SUBJECT_OPTIONS = [
  'Business',
  'Communications',
  'Economics',
  'Government',
  'Civics',
  'History',
  'English',
  'Journalism',
  'Other',
];

const SUBJECT_KNOWN = SUBJECT_OPTIONS.filter((o) => o !== 'Other');

function parseSubjects(str) {
  const parts = (str || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  const selected = [];
  let otherText = '';
  for (const part of parts) {
    if (SUBJECT_KNOWN.includes(part)) {
      selected.push(part);
    } else if (part === 'Other') {
      if (!selected.includes('Other')) selected.push('Other');
    } else {
      if (!selected.includes('Other')) selected.push('Other');
      otherText = part;
    }
  }
  return { selected, otherText };
}

function serializeSubjects(selected, otherText) {
  return selected
    .map((s) => (s === 'Other' ? otherText || 'Other' : s))
    .join(', ');
}

export default function TeacherInvitedAfterMeetingAboutUs({
  model,
  role,
  user,
  onUpdate,
  onValidate,
  onContinue,
}) {
  const firstName = model.firstName || user?.firstName || '';
  const lastName = model.lastName || user?.lastName || '';
  const schoolName =
    model.schoolName || (user?.schools && user.schools[0]?.name) || '';
  const subjects = model.subjects || '';
  const classes = model.classes || '';
  const [saving, setSaving] = useState(false);
  const { selected: selectedSubjects, otherText: subjectOtherText } =
    parseSubjects(subjects);
  const ROLE_LABELS = {
    schoolAdmin: 'School Admin',
  };
  const roleLabel = role
    ? ROLE_LABELS[role] || role.charAt(0).toUpperCase() + role.slice(1)
    : 'Teacher';

  useEffect(() => {
    onValidate(!!(firstName && lastName));
    // eslint-disable-next-line
  }, [firstName, lastName]);

  return (
    <div className="teacher-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">Step 2 of 3</div>
        <h1 className="step-h1">
          Your {roleLabel.toLowerCase()} account was created.
        </h1>
        <p className="step-sub">Complete your information</p>

        <div className="field-row">
          <div className="field">
            <label htmlFor="confirm-first">First name</label>
            <input
              id="confirm-first"
              type="text"
              value={firstName}
              onChange={(e) =>
                onUpdate({ ...model, firstName: e.target.value })
              }
            />
          </div>
          <div className="field">
            <label htmlFor="confirm-last">Last name</label>
            <input
              id="confirm-last"
              type="text"
              value={lastName}
              onChange={(e) => onUpdate({ ...model, lastName: e.target.value })}
            />
          </div>
        </div>

        <div className="field">
          <label htmlFor="confirm-school">School</label>
          <input id="confirm-school" type="text" value={schoolName} readOnly />
        </div>

        <div className="field">
          <label>
            Subjects you teach <span className="optional">Optional</span>
          </label>
          <div className="subject-chips">
            {SUBJECT_OPTIONS.map((subject) => {
              const isActive = selectedSubjects.includes(subject);
              return (
                <button
                  key={subject}
                  type="button"
                  className={`subject-chip${isActive ? ' subject-chip--active' : ''}`}
                  onClick={() => {
                    const updated = isActive
                      ? selectedSubjects.filter((s) => s !== subject)
                      : [...selectedSubjects, subject];
                    onUpdate({
                      ...model,
                      subjects: serializeSubjects(updated, subjectOtherText),
                    });
                  }}
                >
                  {subject}
                </button>
              );
            })}
          </div>
          {selectedSubjects.includes('Other') && (
            <input
              type="text"
              className="subject-other-input"
              placeholder="Specify other subject"
              value={subjectOtherText}
              onChange={(e) => {
                onUpdate({
                  ...model,
                  subjects: serializeSubjects(selectedSubjects, e.target.value),
                });
              }}
            />
          )}
        </div>

        <div className="field">
          <label htmlFor="confirm-classes">
            Classes you teach <span className="optional">Optional</span>
          </label>
          <input
            id="confirm-classes"
            type="text"
            value={classes}
            placeholder="e.g. Period 1, Section A"
            onChange={(e) => onUpdate({ ...model, classes: e.target.value })}
          />
        </div>

        <button
          type="button"
          className="btn-primary"
          disabled={saving || !firstName || !lastName}
          onClick={async () => {
            setSaving(true);
            await onContinue();
            setSaving(false);
          }}
        >
          {saving ? 'Saving…' : 'Continue'}
        </button>
      </div>
    </div>
  );
}
